import BaseModel from '../model/BaseModel';
import ModelArray from './ModelArray';
import Cinema from './Cinema';
import Collection from './Collection'

const MAX_LOCATION_RADIUS = 20;

/**
 * Collection of regions with Methods to format the regions into usable objects.
 */
export class Regions extends Collection {

    constructor(data) {
        super();
        this.data = new ModelArray(data, Region);
    }


    _getDistanceFromLatLongs(latStart, longStart, latFind, longFind) {
        var deg2rad = (deg)=>deg * (Math.PI / 180),
            R = 6371,
            dLat = deg2rad(latFind - latStart),
            dLon = deg2rad(longFind - longStart),
            a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(deg2rad(latStart)) * Math.cos(deg2rad(latFind)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2),
            c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)),
            d = R * c
        return Math.round((d * 100)) / 100;
    }

    cinemasCloseTo(lat, long) {
        return this.cinemas.filter((c,i,self)=> {
            var distance = this._getDistanceFromLatLongs(lat, long, c.latitude, c.longitude);
            c.distance = distance;
            return distance <= MAX_LOCATION_RADIUS && self.findIndex((c2)=>c2.name === c.name) === i;
        }).sort((c,c2)=>c.distance - c2.distance);
    }

    findByCinemas(arrayOfCinemaIds){
        var regions = [];
        for (var i = 0; i < this.data.length; i++) {
            var region = Object.assign({},this.data[i]);
            region.cinemas = region.cinemas.filter((c)=>~arrayOfCinemaIds.indexOf(c.id))
            if(region.cinemas.length > 0) regions.push(region)

        }
        return regions;
    }


    findCimema(id){
        return this.cinemas.find((c)=>c.id == id)
    }

    findCinemaBySlug(slug) {
        return this.cinemas.find((c) => c.slug == slug);
    }
    /**
     * Creates a readonly property on regions that is a flat object of all cinemas.
     * @returns {*}
     */
    get cinemas() {
        return this.data.reduce((c, r)=>c.concat(r.cinemas), []);
    }

}


/**
 * Single Region Object.
 */
export class Region extends BaseModel {

    constructor(data) {
        super();
        this.id = data.id;
        this.name = data.name;
        this.cinemas = data.cinemas && new ModelArray(data.cinemas, Cinema);
        this.distance = ""
    }


}




// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/Regions.js